import React, { useContext } from 'react';
import AppContext from 'context/Context';
import { Button, Table, Form, FormControl, Modal } from 'react-bootstrap';

/**
 * @description 위생검사 결과 반송 등록 및 상세 Modal
 */

function HygieneModal(props) {
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* props */
  const { modalShow, setModalShow, requestInfo, setRequestInfo, modalConfirm } =
    props || {};

  /* state */

  /* event*/
  const handleClose = () => {
    setModalShow(!modalShow);
  };

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title>
          {requestInfo.sendBkYn === 'Y' ? '반송 사유 보기' : '반송 사유 등록'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered className="fs--1 text-center">
          <tbody>
            <tr>
              <th className="bg-200 text-700">공장</th>
              <td>{requestInfo.pltNm || '-'}</td>
              <th className="bg-200 text-700">채취일자</th>
              <td>{requestInfo.coltYmd || '-'}</td>
              <th className="bg-200 text-700">시료명</th>
              <td>{requestInfo.sampleNm || '-'}</td>
              <th className="bg-200 text-700">축종명</th>
              <td>{requestInfo.ctgryGrpNm || '-'}</td>
            </tr>
          </tbody>
        </Table>

        {requestInfo.ctgryGrpCd === 'rwmtr' && (
          <p className="fs--1 text-dark mb-3">
            <span className="me-3">원료 정보</span>모선명 :{' '}
            {requestInfo.cshipNm || '-'} | 원산지명 :{' '}
            {requestInfo.coriNm || '-'}
          </p>
        )}

        <Form.Group className="mb-3">
          <Form.Label>
            {' '}
            *반송 사유{' '}
            {requestInfo.sendBkYn === 'Y' &&
              `[등록일: ${requestInfo.sendBkRegDt}]`}
          </Form.Label>
          <FormControl
            as="textarea"
            placeholder="반송 사유를 입력해주세요.(1000자)"
            size="sm"
            className="vh-25"
            maxLength="1000"
            value={requestInfo.sendBkMsg || ''}
            onChange={e =>
              setRequestInfo({ ...requestInfo, sendBkMsg: e.target.value })
            }
            disabled={requestInfo.sendBkYn === 'Y'}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          {requestInfo.sendBkYn === 'Y' ? '확인' : '취소'}
        </Button>
        {requestInfo.sendBkYn === 'N' && (
          <Button
            className="ms-2"
            onClick={modalConfirm}
            disabled={requestInfo.sendBkMsg === ''}
          >
            등록
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default HygieneModal;
